"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextOverflowing = exports.getRelativeTextWidth = void 0;
// automatically generated by measuring individual characters relative size compared to 1 rem
const relativeCharWidthMap = Object.freeze({
    a: 0.563,
    b: 0.563,
    c: 0.5,
    d: 0.563,
    e: 0.5,
    f: 0.375,
    g: 0.563,
    h: 0.563,
    i: 0.25,
    j: 0.25,
    k: 0.5,
    l: 0.25,
    m: 0.875,
    n: 0.563,
    o: 0.563,
    p: 0.563,
    q: 0.563,
    r: 0.313,
    s: 0.5,
    t: 0.313,
    u: 0.563,
    v: 0.5,
    w: 0.75,
    x: 0.5,
    y: 0.5,
    z: 0.5,
    A: 0.625,
    B: 0.625,
    C: 0.625,
    D: 0.688,
    E: 0.563,
    F: 0.563,
    G: 0.688,
    H: 0.688,
    I: 0.25,
    J: 0.563,
    K: 0.625,
    L: 0.563,
    M: 0.875,
    N: 0.688,
    O: 0.688,
    P: 0.625,
    Q: 0.688,
    R: 0.625,
    S: 0.625,
    T: 0.625,
    U: 0.625,
    V: 0.625,
    W: 0.875,
    X: 0.625,
    Y: 0.625,
    Z: 0.625,
    ' ': 0,
    '.': 0.25,
    ',': 0.188,
    '!': 0.25,
    '?': 0.5,
    '-': 0.25,
    _: 0.438,
    ':': 0.25,
    "'": 0.188,
    '"': 0.313,
    '(': 0.313,
    ')': 0.375,
    '[': 0.25,
    ']': 0.25,
    '{': 0.313,
    '}': 0.313,
    '\\': 0.438,
    '/': 0.438,
    '|': 0.25,
    '@': 0.875,
    '#': 0.625,
    $: 0.563,
    '%': 0.75,
    '^': 0.438,
    '&': 0.625,
    '*': 0.438,
    '+': 0.563,
    '=': 0.563,
    '<': 0.5,
    '>': 0.5,
});
const averageWidth = Object.values(relativeCharWidthMap).reduce((acc, val) => acc + val, 0) /
    Object.values(relativeCharWidthMap).length;
const getRelativeTextWidth = (text, fontSizeRem = 1) => {
    const totalWidthRem = [...text].reduce((acc, char) => {
        const charWidth = relativeCharWidthMap[char] ?? averageWidth; // fallback average
        return acc + charWidth;
    }, 0);
    return totalWidthRem * fontSizeRem;
};
exports.getRelativeTextWidth = getRelativeTextWidth;
const isTextOverflowing = (text, containerWidthRem, fontSizeRem = 1) => {
    const width = (0, exports.getRelativeTextWidth)(text, fontSizeRem);
    return width > containerWidthRem;
};
exports.isTextOverflowing = isTextOverflowing;
